import { Phone } from "lucide-react";
import { cn } from "@/lib/utils";

interface ContactInfoProps {
  className?: string;
  isScrolled?: boolean;
}

const ContactInfo = ({ className, isScrolled }: ContactInfoProps) => {
  return (
    <a
      href="tel:+13237841577"
      className={cn(
        "flex items-center text-sm font-medium hover:text-accent transition-colors",
        isScrolled ? "text-foreground/80" : "text-primary-foreground/90",
        className
      )}
    >
      <Phone className="w-4 h-4 mr-1.5 text-accent" />
      <span>(323) 784-1577</span>
    </a>
  );
};

export default ContactInfo;
